<template>
    <div class="weChatRecharge">
        <h2>微信支付中～</h2>
    </div>
</template>

<script>
import { getTransferWx } from "@/api/other.js"
export default {
    name: 'weChatRecharge',
    data () {
        return {
            trade_no: this.$route.query.trade_no,
            callbackUrl: this.$route.query.callbackUrl
        }
    },
    created () {
        if (this.callbackUrl) {
            window.location.href = this.callbackUrl
        } else {
            this.getTransferWx()
        }
    },
    methods: {
        async getTransferWx () {
            const params = {
                trade_no: this.trade_no
            }
            const res = await getTransferWx(params)
            if (res.errno === 0) {
                if (res.data) {
                    window.location.href = res.data.target_url
                } else {
                    this.$toast('无此流水号！')
                }
            } else {
                this.$toast(res.errmsg)
            }
        }
    }
}
</script>

<style lang="less" scoped>
</style>
